var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgToastWarning = function SvgToastWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "toast_warning_svg__a",
    width: 19,
    height: 19,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h19v19H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#toast_warning_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F11B1B",
    d: "M2.713 16.23a.693.693 0 0 1-.61-.358.76.76 0 0 1-.102-.347.65.65 0 0 1 .1-.37L8.88 3.45a.71.71 0 0 1 .623-.358q.182 0 .348.087a.7.7 0 0 1 .275.27l6.777 11.708a.65.65 0 0 1 .1.37.76.76 0 0 1-.35.605.7.7 0 0 1-.362.098zm.811-1.188H15.48L9.502 4.75zm5.978-.944a.62.62 0 0 0 .455-.184.62.62 0 0 0 .184-.455.62.62 0 0 0-.184-.456.62.62 0 0 0-.455-.184.62.62 0 0 0-.456.184.62.62 0 0 0-.184.456q0 .27.184.455a.62.62 0 0 0 .456.184m0-2.07q.253 0 .423-.171a.57.57 0 0 0 .17-.423V8.663a.57.57 0 0 0-.17-.423.57.57 0 0 0-.424-.171.57.57 0 0 0-.423.17.57.57 0 0 0-.17.424v2.77q0 .253.17.424.172.17.424.17"
  }))));
};
export default SvgToastWarning;